// extracted by mini-css-extract-plugin
module.exports = {"full-width":"button_full-width__2qm63"};